import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { Tag } from 'antd';
import styled from 'styled-components';
import { type IModuleTriggerWidget } from './IModuleTriggerWidget.ts';

export interface IModuleTriggerPreviewComponentProps
  extends IWidgetComponentProps<IModuleTriggerWidget> {}

const ModuleTriggerPreviewStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  position: relative;
  min-height: 40px;
  border-radius: ${props => props.theme.borderRadius}px;
  background-color: ${props => props.theme.colorBorderSecondary};
  font-size: 136px;
`;

/**
 * A differenza del componente di compilazione che è invisibile, mostriamo un placeholder
 */
export function ModuleTriggerPreviewComponent(
  props: IModuleTriggerPreviewComponentProps,
) {
  const { widget } = props;
  return (
    <ModuleTriggerPreviewStyled>
      <Tag style={{ fontSize: '14px' }}>
        {widget.code ?? 'Attivatore modulo'}
      </Tag>
    </ModuleTriggerPreviewStyled>
  );
}
